export default "__VITE_ASSET__BR5u$fo9__"